import { render, staticRenderFns } from "./NotificationInbox.vue?vue&type=template&id=473c5d6c"
import script from "./NotificationInbox.vue?vue&type=script&lang=js"
export * from "./NotificationInbox.vue?vue&type=script&lang=js"
import style0 from "./NotificationInbox.vue?vue&type=style&index=0&id=473c5d6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports